<template>
  <div class="dialog-custom-patch">
    <div class="sectionTitle">客服信息</div>
    <Table :columns="columns" :data="customList"></Table>
    <div class="sectionTitle">已分配单位</div>
    <Table :columns="patchedColumns" :data="patchedList"></Table>
    <div class="sectionTitle">可分配单位</div>
    <Form :model="searchParam" :label-width="100" inline>
      <FormItem label="单位代码：">
        <Input v-model="searchParam.code" placeholder="请输入单位代码"></Input>
      </FormItem>
      <FormItem label="单位名称：">
        <Input v-model="searchParam.name" placeholder="请输入单位名称"></Input>
      </FormItem>
      <FormItem :label-width='20'>
       <Button type="primary" @click="handleSearch">查询</Button>
      </FormItem>
    </Form>
    <Table :columns="enableColumns" :data="enableList" @on-selection-change="changeChoose"></Table>
    <div class="footer">
      <div><Button type="primary" @click="patch">分配</Button></div>
      <div class="totalCount">共{{totalCount}}条</div>
      <Page @on-change='handlePage' :total="totalCount" :page-size='page.pageSize' :current="page.currPage" simple/>
    </div>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
export default {
  props: {
    query: '' // id, name, code
  },
  data () {
    return {
      customList: [],
      patchedList: [],
      enableList: [],
      selection: [],
      searchParam: {},
      totalCount: 0,
      page: {
        currPage: 1,
        pageSize: 5
      },
      columns: [
        {
          title: '账号',
          key: 'username'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '手机号',
          key: 'mobile'
        },
        {
          title: '电子邮箱',
          key: 'email'
        }
      ],
      patchedColumns: [
        {
          title: '单位代码',
          key: 'schoolCode'
        },
        {
          title: '单位名称',
          key: 'schoolName'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.cancelPatch(params)
                  }
                }
              }, '取消分配')
              // h('Button', {
              //   props: {
              //     type: 'error',
              //     size: 'small'
              //   },
              //   on: {
              //     click: () => {
              //       this.remove(params.index)
              //     }
              //   }
              // }, 'Delete')
            ]);
          }
        }
      ],
      enableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '单位代码',
          key: 'code'
        },
        {
          title: '单位名称',
          key: 'name'
        }
      ],
      formLoading: true,
      flag: false
    }
  },
  created () {
    if (this.query) {
      this.searchParam.userId = this.query
      this.fetchCustomMsg()
      this.postEnableList(this.page)
      this.formLoading = false;
    } else {
      this.formLoading = false;
    }
  },
  methods: {
    /**
     * 获取role的详细信息
     */
    async fetchCustomMsg () {
      let url = '/custom/customPermission/info/'
      let res = await this.fetch(url + this.query)
      this.customList = [res.data.user]
      this.patchedList = res.data.userList
    },
    async postEnableList (page) {
      let url = '/custom/customPermission/unitList'
      let param = {
        query: this.searchParam,
        page
      };
      let res = await this.post(url, param)
      this.flag = await true
      this.totalCount = res.data.page.totalCount
      this.enableList = res.data.list
    },
    handleSearch () {
      this.postEnableList(this.page)
    },
    handlePage (currPage) {
      this.page = Object.assign(this.page, {currPage})
      this.postEnableList(this.page)
    },
    async cancelPatch (params) {
      if (this.flag) {
        let url = '/custom/customPermission/delete/'
        let res = await this.post(url + params.row.id)
        if (res.code === 200) {
          this.reloadList()
          this.$Message.success('取消成功')
          this.flag = false
        }
      }
    },
    async patch () {
      let url = '/custom/customPermission/saveOrUpdate'
      let res = await this.post(url, this.selection)
      if (res.code === 200) {
        this.reloadList()
        this.selection = []
        this.$Message.success('分配成功')
      }
    },
    changeChoose (selection) {
      console.log(selection)
      this.selection = []
      selection.forEach(element => {
        this.selection.push({
          kfUserId: this.query,
          schoolId: element.id
        })
      })
    },
    reloadList () {
      this.fetchCustomMsg()
      this.postEnableList(this.page)
    },
    /**
     * 框架弹窗确认时被调用，必须方法
     * @returns {Promise<any>}
     */
    dialogComfirm () {
      return new Promise((resolve, reject) => {
        resolve()
      });
    }
  }
}
</script>

<style lang='less' scoped>
.dialog-custom-patch {
  line-height: 50px;
  .sectionTitle {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
  }
  .footer{
  display: flex;
  justify-content: space-between;
    .totalCount{
    width:530px;
    text-align:right;
  }
  /deep/.kh-page {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/patchUnit.vue